// UserDashboard.js
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import AdminLayout from '../TemplatePage/_admin/AdminLayout';
import './UserDashboard.css';

const UserDashboard = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const adminName = localStorage.getItem('username');
  const userRole = localStorage.getItem('role');
  const userSlug = localStorage.getItem('slug');

  // ==========================================
  // CONTROL DE ACCESO
  // ==========================================
  useEffect(() => {
    const token = localStorage.getItem('token');
    
    // 🔒 Si no hay token, redirigir al login
    if (!token) {
      navigate('/');
      return;
    }

    // Si es Administrador común, debe tener el slug correcto
    if (userRole === 'Administrador' && userSlug && userSlug !== slug) {
      console.warn(`[ACCESO COMPROMETIDO] Intentó ver ${slug}. Redirigiendo a ${userSlug}`);
      alert("No tienes autorización para administrar este evento específico.");
      navigate(`/admin/dashboard/${userSlug}`);
      return;
    }

    // Si no hay slug, redirigir
    if (!slug) {
      navigate('/admin/eventos');
    }
  }, [slug, userSlug, userRole, navigate]);

  // ==========================================
  // RENDER
  // ==========================================
  return (
    <div className="user-dashboard-container">
      <Helmet>
        <title>{`InovateSport | Panel de ${adminName || 'Administrador'}`}</title>
        <meta name="description" content="Panel de administración de eventos" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=yes" />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>

      {/* ✅ AdminLayout se encarga de TODO: Banner, ColorPicker, BankSettings, etc. */}
      <AdminLayout slug={slug} />
    </div>
  );
};

export default UserDashboard;